module.exports = __webpack_public_path__ + "jtails-build/img/service3@2.d6eabe42.jpg";